import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Inner = styled.div`
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
`;

export const QuestionText = styled.div`
  position: relative;
  transition: 0.1s ease-in-out all;
`;

interface IIconProps {
  isOpen: boolean;
}

export const Icon = styled.div`
  transition: 0.2s ease-in-out all;
  transform: ${(props: IIconProps) =>
    props.isOpen ? "rotate(180deg)" : "rotate(0deg)"};

  &:hover {
    color: #79D9D9;
  }
`;

interface IQuestionProps {
  isOpen: boolean;
}

export const Question = styled.div`
  padding: 20px;
  font-size: 1.1em;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-radius: ${(props: IQuestionProps) =>
    props.isOpen ? "8px 8px 0 0" : "8px"};
  transition: 0.3s ease-in-out all;

  ${mediaMinWidth.smallDesktop} {
    &:hover {
      ${QuestionText} strong {
        color: ${(props: IQuestionProps) => !props.isOpen && "#79D9D9"};
      }

      ${Icon} {
        color: #79D9D9;
      }
    }
  }

  ${mediaMaxWidth.smallDesktop} {
    font-size: 1em;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.9em;
    padding: 15px 20px;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.8em;
    padding: 10px 12px;
  }
`;

interface IQuestionTextUnderlineProps {
  isOpen: boolean;
}

export const QuestionTextUnderline = styled.div`
  height: 3px;
  background-color: #79D9D9;
  transition: 0.3s ease-in-out all;
  width: ${(props: IQuestionTextUnderlineProps) =>
    props.isOpen ? "100%" : "0%"};
  position: absolute;
  bottom: -5px;
  z-index: 1;
`;

export const AnswerWrapper = styled.div`
  overflow: hidden;
  transition: 0.3s ease-in-out all;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 920px;

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 100px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }
`;

export const Answer = styled.div``;

interface ITextProps {
  isOpen: boolean;
}

export const Text = styled.div`
  width: 700px;
  text-align: justify;
  margin: 10px auto;
  transition: 0.3s ease-in-out all;
  opacity: ${(props: ITextProps) => (props.isOpen ? "1" : "0")};

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 260px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 100px);
    font-size: 0.9em;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 44px);
    font-size: 0.8em;
  }
`;

interface IVideoPlayerWrapperProps {
  isOpen: boolean;
}

export const VideoPlayerWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  justify-content: center;
  margin: 20px 0 30px 0;
  transition: 0.3s ease-in-out all;
  opacity: ${(props: IVideoPlayerWrapperProps) => (props.isOpen ? "1" : "0")};
`;

export const VideoPlayerWrapperInner = styled.div`
  border-radius: 16px;
  overflow: hidden;
  width: 700px;

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 260px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 100px);
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 44px);
  }
`;
